var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListOngoing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.185 10.3578C10.1352 10.4689 10.0629 10.5655 9.97378 10.64L6.14785 13.84C6.04127 13.9291 5.91453 13.9834 5.78183 13.9968C5.64914 14.0101 5.51574 13.982 5.39657 13.9155C5.27741 13.8491 5.17719 13.747 5.10714 13.6206C5.0371 13.4942 5 13.3486 5 13.2V6.8C5 6.65143 5.0371 6.5058 5.10714 6.37942C5.17719 6.25303 5.27741 6.1509 5.39657 6.08446C5.51574 6.01802 5.64914 5.98989 5.78183 6.00323C5.91453 6.01658 6.04127 6.07086 6.14785 6.16L9.97378 9.36C10.0629 9.43452 10.1352 9.53114 10.185 9.64223C10.2348 9.75331 10.2607 9.8758 10.2607 10C10.2607 10.1242 10.2348 10.2467 10.185 10.3578Z",
    stroke: "#3B82F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9243 10.3578C15.8745 10.4689 15.8021 10.5655 15.713 10.64L11.8871 13.84C11.7805 13.9291 11.6538 13.9834 11.5211 13.9968C11.3884 14.0101 11.255 13.982 11.1358 13.9155C11.0167 13.8491 10.9164 13.747 10.8464 13.6206C10.7764 13.4942 10.7393 13.3486 10.7393 13.2V6.8C10.7393 6.65143 10.7764 6.5058 10.8464 6.37942C10.9164 6.25303 11.0167 6.1509 11.1358 6.08446C11.255 6.01802 11.3884 5.98989 11.5211 6.00323C11.6538 6.01658 11.7805 6.07086 11.8871 6.16L15.713 9.36C15.8021 9.43452 15.8745 9.53114 15.9243 9.64223C15.9741 9.75331 16 9.8758 16 10C16 10.1242 15.9741 10.2467 15.9243 10.3578Z",
    stroke: "#3B82F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#3B82F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOngoing);
export default __webpack_public_path__ + "static/media/list_ongoing.277142f4e80bec9b3cdf7aa0aaf10071.svg";
export { ForwardRef as ReactComponent };